import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '@/utils/auth'

export const Route = createFileRoute('/route-planner/$areaId/$routeId/$version')({
  beforeLoad: () => requirePermission('routes', 'write'),
  component: () => null,
})
